module.exports = __webpack_public_path__ + "media/images/result_sets/circles/4r5r1r2n-6a16633ae146b881972e6b11e8a47a42.svg";